export function getBrowserTimezone(): string {
  return Intl.DateTimeFormat().resolvedOptions().timeZone
}

// EXPL: `settings.defaults.timezone` is '' until the settings defaults land, and `TZDate.tz('')`
// throws a RangeError. Every consumer of a stored timezone resolves it here so the form that
// validates a schedule and the thunk that creates the post can never disagree about the zone.
export function resolveTimezone(timezone?: string | null): string {
  return timezone || getBrowserTimezone()
}
